//
import WebComponent from '../webComponents/WebComponent';
import {dispatchEvent} from 'fg-frontend/src/lib/dom';
import MarkerClusterer from '@google/markerclustererplus';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';

/**
 * Branch picker - komponenta umoznujici vyber pobocky ze seznamu nebo na Google mape na zaklade nejblizsich pobocek
 * urcenych bud dle geolokace nebo naseptavacem mist (Google places API). Pokud neni ani jedna z techto moznosti dostupna,
 * nacte se seznam prvnich x pobocek dle abecedy
 *
 */

// Component fragments
const FRAGMENT = {
  autocomplete: '[data-frag="autocomplete"]',
  autocompleteGeolocation: '[data-frag="autocomplete-geolocation"]',
  geolocation: '[data-frag="geolocation"]',
  nav: '[data-frag="nav"]',
  listPicker: '[data-frag="list-picker"]',
  mapPicker: '[data-frag="map-picker"]',
  map: '[data-frag="map"]',
  info: '[data-frag="info"]',
  list: '[data-frag="list"]',
  btn: '[data-frag="btn"]',
  btnCancel: '[data-frag="btn-cancel"]',
  btnGeolocation: '[data-frag="btn-geolocation"]',
};

// Geolocation options
const GEOLOCATION = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
};

// vychozi lat, lng, a zoom dle statu
const STATES = {
  'cz': {
    'lat': 49.8028,
    'lng': 15.4730,
    'zoom': 8,
  },
  'sk': {
    'lat': 48.6310,
    'lng': 19.6995,
    'zoom': 8,
  },
  'pl': {
    'lat': 51.8545,
    'lng': 19.1344,
    'zoom': 7,
  },
  'hu': {
    'lat': 47.1297,
    'lng': 19.5050,
    'zoom': 8,
  }
}

Node.prototype.appendData = function (postfix, content) {
  if (typeof (content) != 'undefined') {
    const span = document.createElement('div');
    span.classList.add(`branch-picker__${postfix}`);
    span.innerHTML = content;
    this.appendChild(span);
  }
};


class BranchPicker extends WebComponent {
  constructor(props) {
    super(props);
    this.map = null;
    this.autocomplete = null;
    this.defaultCurrentPosition = true;
    this.positionMarkerSet = false;
    this.mobileView = 'list';
    this.locationLat = null;
    this.locationLng = null;
    this.locationZoom = null;
    this.mapMarkers = [];
    this.markerCluster = null;
    this.positionMarker = null;
    this.geolocationActive = false;
    this.selectedBranch = this.setSelectedBranch();
    this.initMap = this.initMap.bind(this);
    this.initAutocomplete = this.initAutocomplete.bind(this);
    this.resetAutocomplete = this.resetAutocomplete.bind(this);
    this.updateAutocompleteCloseButtonState = this.updateAutocompleteCloseButtonState.bind(this);
    this.initGeolocation = this.initGeolocation.bind(this);
    this.enforceGeolocation = this.enforceGeolocation.bind(this);
    this.geolocationSuccess = this.geolocationSuccess.bind(this);
    this.geolocationError = this.geolocationError.bind(this);
    this.showError = this.showError.bind(this);
    this.hideError = this.hideError.bind(this);
    this.close = this.close.bind(this);
    this.selectBranch = this.selectBranch.bind(this);
    this.setBranch = this.setBranch.bind(this);
    this.toggleBranchInfo = this.toggleBranchInfo.bind(this);
    this.searchSurroundings = this.searchSurroundings.bind(this);
    this.pickList = this.pickList.bind(this);
    this.pickMap = this.pickMap.bind(this);
  }

  setSelectedBranch() {
    const {
      selectedBranch,
    } = this.props;
    let result = null;

    if (selectedBranch) {
      result = selectedBranch.toString();
    }

    return result;
  }

  didMount() {
    const {
      targetInput,
      branchTypeInput,
      branchType,
      initialGeolocation,
    } = this.props;

    this.autocompleteElement = this.element.querySelector(FRAGMENT.autocomplete);
    this.autocompleteFormGroupElement = this.autocompleteElement.parentNode;
    this.autocompleteHelpBlockElement = this.autocompleteFormGroupElement.querySelector('.help-block');
    this.autocompleteGeolocationElement = this.element.querySelector(FRAGMENT.autocompleteGeolocation);
    this.geolocationElement = this.element.querySelector(FRAGMENT.geolocation);
    this.navElement = this.element.querySelector(FRAGMENT.nav);
    this.listPickerElement = this.element.querySelector(FRAGMENT.listPicker);
    this.mapPickerElement = this.element.querySelector(FRAGMENT.mapPicker);
    this.mapElement = this.element.querySelector(FRAGMENT.map);
    this.listElement = this.element.querySelector(FRAGMENT.list);
    this.infoElement = this.element.querySelector(FRAGMENT.info);
    this.btnElement = this.element.querySelector(FRAGMENT.btn);
    this.btnCancelElement = this.element.querySelector(FRAGMENT.btnCancel);
    this.btnGeolocationElement = this.element.querySelector(FRAGMENT.btnGeolocation);
    this.targetInputElement = document.querySelector('#' + targetInput);
    this.branchTypeInput = branchTypeInput;
    this.branchType = branchType;
    this.branchTypeLabel = this.getBranchTypeLabel(branchTypeInput);

    // update button visibility
    this.updateButton();

    // update components visibility
    this.updateControlComponents();
    this.updateViewComponents();

    // get location and zoom from cookies or set from defaults
    this.getCurrentPosition();

    // init map
    this.initMap();

    // init geolocation
    if (initialGeolocation) {
      this.initGeolocation();
    }

    // init autocomplete
    this.initAutocomplete();

    // init search surroundings
    this.initSearchSurroundings();

    // bind events
    this.bindEvents();
  }

  // binds event listeners to common components
  bindEvents() {
    this.btnCancelElement.addEventListener('click', this.close);
    this.btnGeolocationElement.addEventListener('click', this.enforceGeolocation);
    this.btnElement.addEventListener('click', this.setBranch);
    this.autocompleteGeolocationElement.addEventListener('click', this.enforceGeolocation);
    this.listPickerElement.addEventListener('click', this.pickList);
    this.mapPickerElement.addEventListener('click', this.pickMap);

    document.addEventListener('click', (e) => {
      if (e.target && e.target.id == 'branchPickerBubbleBtn') {
        this.setBranch(e);
      }
    });
  }

  // picks list element
  pickList(e) {
    e.preventDefault();
    this.mobileView = 'list';
    this.updateViewComponents();
    this.element.classList.remove('map');
    this.element.classList.add('list');


    this.listPickerElement.classList.add('active');
    this.mapPickerElement.classList.remove('active');
  }

  // picks map element
  pickMap(e) {
    e.preventDefault();
    this.mobileView = 'map';
    this.updateViewComponents();
    this.element.classList.add('map');
    this.element.classList.remove('list');

    this.mapPickerElement.classList.add('active');
    this.listPickerElement.classList.remove('active');
  }

  // closes popup window
  close(e) {
    if (typeof (e) != 'undefined') e.preventDefault();
    window.edeeshopPopup.close();
  }

  // gets branch type label
  getBranchTypeLabel(input) {
    const radios = document.getElementsByName(`frm.${input}`);
    for (let i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        return radios[i].parentElement.querySelector('.label').textContent.trim();
        break;
      }
    }
  }

  // inits geolocation
  initGeolocation() {
    if (this.defaultCurrentPosition) {
      this.processGeolocation();
    } else {
      this.setPositionMarker();
    }
  }

  // enforces geolocation
  enforceGeolocation(e) {
    e.preventDefault();
    this.processGeolocation();
  }

  processGeolocation() {
    const geolocation = navigator.geolocation;
    this.autocompleteElement.value = '';
    this.locationName = '';
    geolocation.getCurrentPosition(this.geolocationSuccess, this.geolocationError, GEOLOCATION);
  }

  // handles geolocation success
  geolocationSuccess(pos) {
    const crd = pos.coords;
    const {
      zoom,
    } = this.props;

    this.geolocationActive = true;
    this.setCurrentPosition(crd.latitude, crd.longitude, zoom, '');
  }

  // handles geolocation error
  geolocationError(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
    this.geolocationActive = false;
    this.getDefaultCurrentPosition();
    this.setPositionMarker();
  }


  // inits Google map and position marker
  initMap() {
    this.map = new google.maps.Map(this.mapElement, {
      center: {
        lat: this.locationLat,
        lng: this.locationLng,
      },
      zoom: this.locationZoom,
      streetViewControl: false,
      styles: [
        {
          'featureType': 'poi',
          'stylers': [
            {
              'visibility': 'off',
            }
          ],
        }
      ],
    });

    // init position marker
    this.positionMarker = new google.maps.Marker({map: this.map});
  }

  // sets position marker on map by current location setting and start branches data load
  setPositionMarker() {
    const location = new google.maps.LatLng(this.locationLat, this.locationLng);
    this.map.setCenter(location);
    this.map.setZoom(this.locationZoom);

    this.positionMarker.setPosition(location);
    if (this.defaultCurrentPosition) {
      this.positionMarker.setVisible(false);
    }
    else {
      this.positionMarker.setVisible(true);
    }

    this.positionMarkerSet = true;

    this.getBranches();
  }

  // makes ajax request to data provider and retrieves branch data, if successfull, starts list and map update
  getBranches() {
    const {
      size,
      fetchUrl,
    } = this.props;

    const xhr = new XMLHttpRequest();
    const data = new FormData();
    if (!this.defaultCurrentPosition) {
      data.append('lat', this.locationLat);
      data.append('lng', this.locationLng);
    }
    data.append('size', size);

    CursorSpinner.pushToQueue('branchPicker');

    xhr.open('POST', fetchUrl);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        CursorSpinner.removeFromQueue('branchPicker');

        if (xhr.status == 200) {
          const jsonData = JSON.parse(xhr.responseText);

          if (typeof (jsonData.items) != 'undefined') {
            this.updateBranchesList(jsonData);
            this.updateBranchesMap(jsonData);
            this.setupSelectedBranch();

            this.updateControlComponents();
            this.updateViewComponents();
          } else {
            console.warn('Chyba v nacitani dat pobocek');
          }
        }
      }
    };
    xhr.send(data);
  }

  // builds branches list, fill it with data and bind choose branch listener
  updateBranchesList(data) {
    // remove old list
    while (this.listElement.firstChild) this.listElement.removeChild(this.listElement.firstChild);
    this.listElement.classList.remove('active');

    const branches = data.items;


    if (branches.length > 0) {
      const list = document.createElement('ul');
      list.classList.add('branch-picker__list');

      for (let i = 0; i < branches.length; i++) {
        let branchData = branches[i];
        let branch = document.createElement('li');
        branch.classList.add('branch-picker__item');
        branch.setAttribute('data-branch-id', branchData.id);
        branch.addEventListener('click', this.selectBranch);

        branch.appendData('title', branchData.title);

        let branchMore = document.createElement('span');
        branchMore.classList.add('branch-picker__more');
        branchMore.appendChild(document.createTextNode(this.i18n('more')));
        branchMore.addEventListener('click', this.toggleBranchInfo);
        branch.appendChild(branchMore);

        let branchLess = document.createElement('span');
        branchLess.classList.add('branch-picker__less');
        branchLess.appendChild(document.createTextNode(this.i18n('less')));
        branchLess.addEventListener('click', this.toggleBranchInfo);
        branch.appendChild(branchLess);

        branch.appendData('address', branchData.address);
        if (this.geolocationActive) {
          branch.appendData('distance', this.formatDistance(branchData.distance));
        }
        branch.appendData('opening-hours', branchData.openingHours);

        if (branchData.photoThumb) {
          let branchPhotoContainer = document.createElement('div')
          branchPhotoContainer.classList.add('branch-picker__photo');
          let branchPhoto = document.createElement('img');
          branchPhoto.classList.add('branch-picker__photo-img');
          branchPhoto.loading = 'lazy';
          branchPhoto.src = branchData.photoThumb;
          branchPhoto.alt = branchData.title;
          branchPhotoContainer.appendChild(branchPhoto);
          branch.appendChild(branchPhotoContainer);
        }

        branch.appendData('note', branchData.note);

        let branchLinkContainer = document.createElement('span');
        branchLinkContainer.classList.add('branch-picker__link-container');
        branch.appendChild(branchLinkContainer);

        let branchLink = document.createElement('a');
        branchLink.classList.add('branch-picker__link');
        branchLink.appendChild(document.createTextNode(this.i18n('choose')));
        branchLink.href = '#';
        branchLink.addEventListener('click', this.setBranch);
        branchLinkContainer.appendChild(branchLink);

        list.appendChild(branch);
      }

      this.listElement.appendChild(list);

    }
    this.listElement.classList.add('active');
  }

  appendSpanData(postfix, content) {
    if (typeof (content != 'undefined')) {
      const span = document.createElement('span');
      span.classList.add(`branch-picker__${postfix}`);
      span.appendChild(document.createTextNode(content));
      return span;
    }
  }

  // setups selectedBranch - starts edit mode
  setupSelectedBranch() {
    if (this.selectedBranch) {
      this.selectBranch(this.selectedBranch);
    }
  }

  // sets current branch as active
  selectBranch(e) {
    let targetItem;

    if (typeof (e) == 'object') {
      this.selectedBranch = e.target.getAttribute('data-branch-id');
      targetItem = e.target;
    } else {
      this.selectedBranch = e;
      targetItem = this.listElement.querySelector(`li[data-branch-id='${e}']`);
    }
    const listItems = this.listElement.querySelectorAll('li');
    const activeItemClass = 'branch-picker__item--active';

    listItems.forEach((listItem) => {
      listItem.classList.remove(activeItemClass);
    });

    if ((this.selectedBranch) && (targetItem)) {
      targetItem.classList.add(activeItemClass);
      this.mapZoomToBranch();
      if (typeof (e) != 'object') {
        this.listZoomToBranch();
      }
    }

    this.updateButton();
  }

  //
  toggleBranchInfo(e) {
    e.preventDefault();
    e.stopPropagation();

    const targetItem = e.target.parentNode;
    const listItems = this.listElement.querySelectorAll('li');
    const openItemClass = 'branch-picker__item--open';

    listItems.forEach((listItem) => {
      if (listItem != targetItem) {
        listItem.classList.remove(openItemClass);
      }
    });

    targetItem.classList.toggle(openItemClass);
  }


  // sets selected branch id to target input element
  setBranch(e) {
    e.preventDefault();

    if (this.selectedBranch) {
      this.targetInputElement.value = this.selectedBranch;
      dispatchEvent(this.targetInputElement, 'change');
      this.close();
    }
  }

  // makes map pan to position by selected branch
  mapZoomToBranch() {
    const mapMarker = this.mapMarkers.find((o, i) => {
      if (o.id === this.selectedBranch) {
        return true;
      }
    });
    if (mapMarker) {
      this.map.setCenter(mapMarker.position);
      this.map.setZoom(17);

      // open map info window
      this.closeInfoWindows();
      mapMarker.infoWindow.open(this.map, mapMarker);
      this.infoElement.innerHTML = mapMarker.infoWindowContent;
    }
  }

  // zooms selected branch in list
  listZoomToBranch() {
    const listItem = this.listElement.querySelector(`li[data-branch-id='${this.selectedBranch}']`);

    if (listItem) {
      window.setTimeout(() => {
        listItem.scrollIntoView({
          behavior: 'smooth',
        });
      }, 100);
    }
  }

  // updates select button visibility
  updateButton() {
    this.btnElement.style.display = this.selectedBranch ? 'block' : 'none';
  }

  // updates control components visibility
  updateControlComponents() {
    if (!this.positionMarkerSet) {
      this.autocompleteGeolocationElement.style.display = 'none';
      this.geolocationElement.style.display = 'block';
      this.navElement.style.display = 'none';
    } else {
      this.autocompleteGeolocationElement.style.display = 'block';
      this.geolocationElement.style.display = 'none';
      this.navElement.style.display = 'flex';
    }
  }

  // updates view components (map/list) visibility
  updateViewComponents() {
    if (!this.positionMarkerSet) {
      this.mapElement.style.display = 'none';
      this.listElement.style.display = 'none';
    } else {
      if (this.mobileView == 'map') {
        this.mapElement.style.display = 'block';
        this.listElement.style.display = 'none';
        this.infoElement.style.display = 'block';
      } else {
        this.mapElement.style.display = 'none';
        this.listElement.style.display = 'block';
        this.infoElement.style.display = 'none';
      }
    }

  }

  // updates branch markers on map
  updateBranchesMap(data) {
    const self = this;

    const branches = data.items;
    let marker, branchData, infoWindowContent;

    this.mapPoints = [];

    const markerClusterClassName = `branch-picker__cluster--${this.branchType}`;
    const mapImage = {
      url: `/img/branch-picker/ico-${this.branchType}.png`,
      size: new google.maps.Size(30, 43),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(15, 43)
    };

    // reset cluster
    if (this.markerCluster && this.mapMarkers) {
     this.markerCluster.removeMarkers(this.mapMarkers, true);
    }

    // reset map markers
    for(var i=0; i < this.mapMarkers.length; i++){
      this.mapMarkers[i].setMap(null);
    }

    this.mapMarkers = [];

    if (branches.length > 0) {
      for (let i = 0; i < branches.length; i++) {
        branchData = branches[i];
        branchData.type = this.branchTypeLabel;

        marker = new google.maps.Marker({
          id: branchData.id,
          position: new google.maps.LatLng(branchData.lat, branchData.lng),
          map: this.map,
          title: branchData.title,
          cursor: 'pointer',
          icon: mapImage,
        });

        this.mapPoints.push(new google.maps.LatLng(branchData.lat, branchData.lng));

        infoWindowContent = `<div class="branch-picker__bubble"><p class="branch-picker__bubble-type">${branchData.title}</p><h3 class="branch-picker__bubble-title">${branchData.address}</h3>`;
        if (branchData.openingHours) {
          infoWindowContent += `<p class="branch-picker__bubble-opening-hours">${branchData.openingHours}</p>`;
        }
        infoWindowContent += `<a href="#" class="branch-picker__bubble-btn" id="branchPickerBubbleBtn">${this.i18n('choose')}</a>`;
        infoWindowContent += `</div>`;

        marker['infoWindowContent'] = infoWindowContent;

        marker['infoWindow'] = new google.maps.InfoWindow({
          content: infoWindowContent,
        });

        google.maps.event.addListener(marker, 'click', function () {
          self.closeInfoWindows();
          this['infoWindow'].open(self.map, this);
          self.selectBranch(this.id);
          self.infoElement.innerHTML = this['infoWindowContent'];
        });

        this.mapMarkers.push(marker);
      }
    }

    // Add a marker clusterer to manage the markers.
    this.markerCluster = new MarkerClusterer(this.map, this.mapMarkers, {
      styles: [{
        width: 30,
        height: 30,
        className: markerClusterClassName,
      },
        {
          width: 40,
          height: 40,
          className: markerClusterClassName,
        },
        {
          width: 50,
          height: 50,
          className: markerClusterClassName,
        }],
      clusterClass: 'branch-picker__cluster',
    });

    // center map by map points
    let latlngbounds = new google.maps.LatLngBounds();
    for (var latLng of this.mapPoints)
      latlngbounds.extend(latLng);

    this.map.setCenter(latlngbounds.getCenter());
    this.map.fitBounds(latlngbounds);

  }

  // closes all opened info window within map
  closeInfoWindows() {
    for (let i = 0; i < this.mapMarkers.length; i++) {
      if (this.mapMarkers[i].infoWindow !== null) {
        this.mapMarkers[i].infoWindow.close();
      }
    }
  }

  // returns formated distance in m ( < 1000) or in km
  formatDistance(distance) {
    let result;

    if (distance) {
      if (distance < 1000) {
        result = Math.round(distance) + ' ' + this.i18n('m');
      } else {
        result = (Math.round(distance / 1000 * 10) / 10).toString().replace('.', ',') + ' ' + this.i18n('km');
      }
    } else {
      result = '';
    }
    return result;
  }

  // inits autocomplete input
  initAutocomplete() {
    const {
      country,
    } = this.props;

    // make close button
    this.autocompleteCloseElement = document.createElement('span');
    this.autocompleteCloseElement.classList.add('branch-picker__autocomplete-close-btn');
    this.autocompleteElement.parentNode.insertBefore(this.autocompleteCloseElement, this.autocompleteElement.nextSibling);
    this.autocompleteCloseElement.addEventListener('click', this.resetAutocomplete);
    this.autocompleteElement.addEventListener('keyup', this.updateAutocompleteCloseButtonState);
    this.updateAutocompleteCloseButtonState();

    let autocompleteOptions = {}

    if (country.length > 0) {
      autocompleteOptions = { componentRestrictions: { country: country }}
    }

    this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteElement, autocompleteOptions);
    this.autocomplete.bindTo('bounds', this.map);

    google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
      //reset selected branch
      this.selectedBranch = null;
      this.updateButton();

      this.positionMarker.setVisible(false);
      this.hideError();

      const place = this.autocomplete.getPlace();

      const {
        zoom,
      } = this.props;

      if (typeof (place) == 'undefined') {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        this.showError(this.i18n('notFound'));
        return;
      }


      // If the place has a geometry, then present it on a map.
      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport);
      }

      this.geolocationActive = false;
      this.setCurrentPosition(place.geometry.location.lat(), place.geometry.location.lng(), zoom, place.name);
    });
  }

  // resets autocomplete input
  resetAutocomplete() {
    this.autocompleteElement.value = '';
    this.updateAutocompleteCloseButtonState();
  }

  // updates autocomplete close button state by autocomplete input state
  updateAutocompleteCloseButtonState() {
    if (this.autocompleteElement.value == "") {
      this.autocompleteCloseElement.classList.add('hidden');
    }
    else {
      this.autocompleteCloseElement.classList.remove('hidden');
    }
  }

  // inits search surroundings feature
  initSearchSurroundings() {
    const controlUI = document.createElement('div');
    controlUI.classList.add('branch-picker__btn--search');
    controlUI.innerHTML = this.i18n('searchSurroundings');
    controlUI.addEventListener('click', this.searchSurroundings);

    this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(controlUI);
  }

  // starts search surrounding request
  searchSurroundings() {
    // reset autocomplete value
    this.autocompleteElement.value = '';
    this.locationName = '';

    // reset selected branch
    this.selectedBranch = null;
    this.updateButton();

    this.geolocationActive = false;
    this.setCurrentPosition(this.map.getCenter().lat(), this.map.getCenter().lng(), this.map.getZoom(), '');
  }

  // show input error
  showError(text) {
    this.autocompleteFormGroupElement.classList.add('has-error');
    this.autocompleteHelpBlockElement.innerHTML = text;
  }

  // hide input error
  hideError() {
    this.autocompleteFormGroupElement.classList.remove('has-error');
    this.autocompleteHelpBlockElement.innerHTML = '';
  }

  // retrieves current position data from localStorage, otherwise sets from default setting
  getCurrentPosition() {
    if ((window.localStorage) && (localStorage.getItem('locationLat'))) {
      this.getSavedCurrentPosition();
    } else {
      this.getDefaultCurrentPosition();
    }
  }

  // gets current positions from saved localStorage data
  getSavedCurrentPosition() {
    this.locationLat = parseFloat(localStorage.getItem('locationLat'));
    this.locationLng = parseFloat(localStorage.getItem('locationLng'));
    this.locationZoom = parseFloat(localStorage.getItem('locationZoom'));
    this.locationName = localStorage.getItem('locationName');
    this.geolocationActive = localStorage.getItem('geolocationActive') == 'true';
    this.defaultCurrentPosition = false;
    this.autocompleteElement.value = this.locationName;
  }

  // gets default current position from default options
  getDefaultCurrentPosition() {
    const {
      defaultLat,
      defaultLng,
      defaultZoom,
      country,
    } = this.props;

    if (country.length > 0) {
      // first country in array is default
      const defaultCountry = country[0];
      this.locationLat = STATES[defaultCountry].lat;
      this.locationLng = STATES[defaultCountry].lng;
      this.locationZoom = STATES[defaultCountry].zoom;
    }
    else {
      this.locationLat = defaultLat;
      this.locationLng = defaultLng;
      this.locationZoom = defaultZoom;
    }

    this.locationName = '';
    this.defaultCurrentPosition = true;
    this.autocompleteElement.value = this.locationName;
  }

  // sets current position data to localStorage and component data
  setCurrentPosition(lat, lng, zoom, name) {
    this.locationLat = lat;
    this.locationLng = lng;
    this.locationZoom = zoom;
    this.locationName = name;
    this.defaultCurrentPosition = false;

    this.saveCurrentPositionToLocalStorage();
    this.setPositionMarker();
  }

  //saves current position component data to localStorage
  saveCurrentPositionToLocalStorage() {
    if (window.localStorage) {
      localStorage.setItem('locationLat', this.locationLat);
      localStorage.setItem('locationLng', this.locationLng);
      localStorage.setItem('locationZoom', this.locationZoom);
      localStorage.setItem('locationName', this.locationName);
      localStorage.setItem('geolocationActive', this.geolocationActive);
    }
  }

}

BranchPicker.defaultProps = {
  defaultLat: 50.08804,
  defaultLng: 14.42076,
  defaultZoom: 4,
  zoom: 13,
  size: 100,
  selectedBranch: null,
  fetchUrl: null,
  initialGeolocation: true,
  country: [],
};

export default BranchPicker;




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/BranchPicker.js